<p>{{ 'app.addons.manage_thesis_works' | translate }}!</p>
